import React from "react";
import { ToastContainer } from "react-toastify";
import AddBlog from "../../components/Blog/AddBlog";

export const AddBlogPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddBlog />
        </div>
      </div>
    </div>
  );
};
